module.exports = "<h3 id=simply-too-good-br-to-dismiss->Simply too good <br>to dismiss.</h3> <h4 id=financial-times>Financial Times</h4> ";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/markdown/carousel/carousel_quote_3.md
// module id = 216
// module chunks = 0